(function() {
    angular
        .module("alertsModule")
        .controller("AlertDetailsMessageBoardController", AlertDetailsMessageBoardController)

    AlertDetailsMessageBoardController.$inject = [
        "$state",
        "$rootScope",
        "$scope",
        "$stateParams",
        "$filter",
        "alertsService",
        "telemetryService",
        "userMessagingService",
        "DTOptionsBuilder",
        "DTColumnBuilder"
    ]

    function AlertDetailsMessageBoardController(
        $state,
        $rootScope,
        $scope,
        $stateParams,
        $filter,
        alertsService,
        telemetryService,
        userMessagingService,
        DTOptionsBuilder,
        DTColumnBuilder
    ){
        "use strict"

        $rootScope.title = "Alert Details | WANCO"

        $scope.alert = {}
        $scope.formData = {}
        $scope.formData.fixed = false

        $scope.updateAlert = function() {
            alertsService.updateAlert(
                "MessageBoard",
                $stateParams.component_id,
                $stateParams.alert_id,
                angular.fromJson($scope.formData),
                function() {
                    //Success
                    alertsService.getAlertCount().then(function(data) {
                        $rootScope.alertCount = data.alerts
                    })

                    $state.go($state.$current, null, { reload: true })
                },
                function(error) {
                    //Failure
                    userMessagingService.error(error)
                }
            )
        }

        $scope.dtAlertOptions = DTOptionsBuilder.fromFnPromise(function() {
                return alertsService.getAlert("MessageBoard", $stateParams.component_id, $stateParams.alert_id).then(function(data) {

                    $scope.alert = data

                    var alertData = [
                        data
                    ]

                    if (data.fixed_by_user_id !== null) {
                        $scope.formData.fixed = true
                    }

                    $scope.formData.comments = data.comments || ""

                    return alertData
                })
            })
            .withOption("paging", false)
            .withOption("bInfo", false)
            .withOption("bFilter", false)
            .withOption("bAutoWidth", true)
            .withLanguage({
                "sEmptyTable":     "No data available in table",
                "sInfo":           "Showing _START_ to _END_ of _TOTAL_",
                "sInfoEmpty":      "Showing 0 to 0 of 0",
                "sLoadingRecords": "Loading...",
                "sZeroRecords":    "No matching records found",
                "oPaginate": {
                    "sNext":     '<button class="btn btn-default pull-right"><i class="fa fa-angle-right"></i></button>',
                    "sPrevious": '<button class="btn btn-default"><i class="fa fa-angle-left"></i></button>'
                },
                "oAria": {
                    "sSortAscending":  ": activate to sort column ascending",
                    "sSortDescending": ": activate to sort column descending"
                }
            })
            .withOption("sDom", '<"top">rt<"clearfix"><"pull-left"l><"pull-right text-right"fip><"clear">')
            .withOption("responsive", true)

        $scope.dtAlertColumns = [
            DTColumnBuilder.newColumn(null).withTitle("Created At")
                .renderWith(function(data, type, full, meta) {
                    const val = $rootScope.presentDateTime(data.created_at, "NumericLongDate", data.timezone_iana).split("@")
                    const d = val[0].trim()
                    let t = ""
                    if (val.length === 2) {
                        t = " <br/><span style='white-space: nowrap;'>" + val[1].trim() + "</span>"
                    }
                    return d + t
                }).notSortable(),
            DTColumnBuilder.newColumn(null).withTitle("Updated At")
                .renderWith(function(data, type, full, meta) {
                    const val = $rootScope.presentDateTime(data.updated_at, "NumericLongDate", data.timezone_iana).split("@")
                    const d = val[0].trim()
                    let t = ""
                    if (val.length === 2) {
                        t = " <br/><span style='white-space: nowrap;'>" + val[1].trim() + "</span>"
                    }
                    return d + t
                }).notSortable(),
            DTColumnBuilder.newColumn(null).withTitle("Details").renderWith(function(data, type, full, meta) {
                let ret = data.title
                if (data.description !== undefined && data.description !== null) {
                    ret += "<br />" + data.description
                }
                return ret
            }).notSortable(),
            DTColumnBuilder.newColumn("fixed_by_username").withTitle("Fixed By").notSortable(),
            DTColumnBuilder.newColumn("comments").withTitle("Comments").notSortable()
        ]

        /**
            Telemetry dataTable config
            @type {*|DTOptions}
         **/
        $scope.dtTelemetryOptions = DTOptionsBuilder.fromFnPromise(function() {
                return telemetryService.getTelemetry("MessageBoard", $stateParams.component_id).then(function(data) {
                    var telemetryData = [
                        data
                    ]
                    return telemetryData
                })
            })
            .withOption("paging", false)
            .withOption("bInfo", false)
            .withOption("bFilter", false)
            .withOption("bAutoWidth", true)
            .withLanguage({
                "sEmptyTable":     "No data available in table",
                "sInfo":           "Showing _START_ to _END_ of _TOTAL_",
                "sInfoEmpty":      "Showing 0 to 0 of 0",
                "sLoadingRecords": "Loading...",
                "sZeroRecords":    "No matching records found",
                "oPaginate": {
                    "sNext":     '<button class="btn btn-default pull-right"><i class="fa fa-angle-right"></i></button>',
                    "sPrevious": '<button class="btn btn-default"><i class="fa fa-angle-left"></i></button>'
                },
                "oAria": {
                    "sSortAscending":  ": activate to sort column ascending",
                    "sSortDescending": ": activate to sort column descending"
                }
            })
            .withOption("sDom", '<"top">rt<"clearfix"><"pull-left"l><"pull-right text-right"fip><"clear">')
            .withOption("responsive", true)

        $scope.dtTelemetryColumns = [
            DTColumnBuilder.newColumn(null).withTitle("Date")
                .renderWith(function(data, type, full, meta) {
                    const val = $rootScope.presentDateTime(data.updated_at, "NumericLongDate", data.timezone_iana).split("@")
                    const d = val[0].trim()
                    let t = ""
                    if (val.length === 2) {
                        t = " <br/><span style='white-space: nowrap;'>" + val[1].trim() + "</span>"
                    }
                    return d + t
                }).notSortable(),
            DTColumnBuilder.newColumn(null).withTitle("System Voltage")
                .renderWith(function(data, type, full, meta) {
                    return $filter("number")((data.voltage_battery || "0.00"), 2) + " V"
                }).notSortable(),
            DTColumnBuilder.newColumn(null).withTitle("Ambient Temperature")
                .renderWith(function(data, type, full, meta) {
                    return $rootScope.displayTemperatureFromF(data.temp_ambient)
                }).notSortable(),
            DTColumnBuilder.newColumn(null).withTitle("Cabinet Temperature")
                .renderWith(function(data, type, full, meta) {
                    return $rootScope.displayTemperatureFromF(data.temp_cabinet)
                }).notSortable(),
            DTColumnBuilder.newColumn(null).withTitle("Sign Housing Temperature")
                .renderWith(function(data, type, full, meta) {
                    return $rootScope.displayTemperatureFromF(data.temp_sign_housing)
                }).notSortable(),
            DTColumnBuilder.newColumn(null).withTitle("LED Brightness")
                .renderWith(function(data, type, full, meta) {
                    return (data.led_brightness || "0.00") + "%"
                }).notSortable()
            // DTColumnBuilder.newColumn("short_error_status").withTitle("Short Error Status").notSortable(),
            // DTColumnBuilder.newColumn("controller_error_status").withTitle("Controller Error Status").notSortable()
        ]

        if ($rootScope.isWancoDevice) {
            $scope.dtTelemetryColumns.splice(4, 0,
                DTColumnBuilder.newColumn(null).withTitle("Solar Voltage")
                    .renderWith(function(data, type, full, meta) {
                        return $filter("number")((data.voltage_solar || "0.00"), 2) + " V"
                    }).notSortable()
            )
            $scope.dtTelemetryColumns.splice(5, 0,
                DTColumnBuilder.newColumn(null).withTitle("System Current")
                    .renderWith(function(data, type, full, meta) {
                        return $filter("number")((data.current_battery || "0.00"), 2) + " A"
                    }).notSortable()
            )
            $scope.dtTelemetryColumns.splice(6, 0,
                DTColumnBuilder.newColumn(null).withTitle("Solar Current")
                    .renderWith(function(data, type, full, meta) {
                        return $filter("number")((data.current_solar || "0.00"), 2) + " A"
                    }).notSortable()
            )
            $scope.dtTelemetryColumns.splice(10, 0,
                DTColumnBuilder.newColumn(null).withTitle("Photocell 1")
                    .renderWith(function(data, type, full, meta) {
                        return (data.photocell_1 || "0.00") + "%"
                    }).notSortable()
            )
            $scope.dtTelemetryColumns.splice(11, 0,
                DTColumnBuilder.newColumn(null).withTitle("Photocell 2")
                    .renderWith(function(data, type, full, meta) {
                        return (data.photocell_2 || "0.00") + "%"
                    }).notSortable()
            )
        }
    }
})()
